import React,{ useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApiClient } from "../../service/API";
import LeaveList from "./LeaveList";
import { useWebSocketContext } from "../WebSocket/WebSocketContext";
import { useAuth } from "../../auth/AuthHandler";
import { getApiErrorMessage } from "../../service/errorHandler";
import UsersLeaveCountList from "./UsersLeaveCountList";
import NotificationModal from "../TicketComponents/NotificationModal";
import "../../styling/Leave.css"

export default function ManageLeavePage(){
    const { expiration, authenticated, userEmail, userName, userRoles, loading, handleLogout, handleLogin, mute, setMute, popup, setPopup } = useAuth();
    const navigate = useNavigate();
    const apiClient = useApiClient();
    const [leaveRequestList, setLeaveRequestList] = useState([]);
    const [onLeavelist, setOnLeaveList] = useState([]);
    const [leaveRequestListLoading, setLeaveRequestListLoading] = useState(false);
    const [onLeaveListLoading, setOnLeaveListLoading] = useState(false);
    const [userList, setUserList] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [showModal, setShowModal] = useState(false);

    const {
        alertMessage,
        manageUserRefresh,
    } = useWebSocketContext();

    const fetchUserList = async () => {
        try {
          const userListGet = await apiClient.get(`/users/bouser-list-leave`);
          setUserList(userListGet.data);
        } catch (error) {
            setErrorMessage(getApiErrorMessage(error, "Error fetching user list."));
            setShowModal(true);
        }
    };


    const fetchLeaveRequestList = async () => {
        setLeaveRequestListLoading(true);
        const response = await apiClient.get('/users/leave-request-list');
        if(response.status === 200){
            setLeaveRequestList(response.data);
            setLeaveRequestListLoading(false);
        }
    };

    const fetchonLeaveList = async () => {
        setOnLeaveListLoading(true);
        try {
          const response = await apiClient.get('/users/onleave-list');
          if (response.status === 200) {
            setOnLeaveList(response.data);
          }
        } catch (error) {
            setErrorMessage(getApiErrorMessage(error, "Error fetching user list."));
            setShowModal(true);
        } finally {
          setOnLeaveListLoading(false);
        }
    };
    
    useEffect(() => {
        if(['BOMANAGER','FOMANAGER', 'ADMIN'].some(role => userRoles.includes(role))){
            fetchLeaveRequestList();
            fetchonLeaveList();
        }
        fetchUserList();
    },[]);

    useEffect(()=>{
        if(manageUserRefresh){
            if(['BOUSER','BOMANAGER','FOMANAGER','ADMIN'].some(role => userRoles.includes(role))){
                fetchLeaveRequestList();
                fetchonLeaveList();
            }
        }
        if(alertMessage){
            if(alertMessage.type === 'LEAVE'){
                if(['BOUSER','BOMANAGER','FOMANAGER','ADMIN'].some(role => userRoles.includes(role))){
                    fetchLeaveRequestList();
                    fetchonLeaveList();
                }
            }
        }
    },[manageUserRefresh, alertMessage]);

    const onApprovalButton = async (id, status) => {
        try {
            // Send the patch request with query parameters
            await apiClient.patch(`/users/leave-request`, null, {
                params: {
                    status: status,  // Query parameter for status
                    leaveId: id      // Query parameter for leaveId
                }
            });

        } catch (error) {
            setErrorMessage(getApiErrorMessage(error, "Error during approval."));
            setShowModal(true);
        }
    };

    const onCancelButton = async (leaveId) => {
        try {
        await apiClient.patch(`/users/cancel-leave/${leaveId}`);
        setErrorMessage("Leave cancel success!");
        setShowModal(true);
        // refreshing lists after cancel is optional; if you want immediate refresh:
        } catch (err) {
            setErrorMessage(getApiErrorMessage(err, "Leave cancel failed."));
            setShowModal(true);
        }
    };
    
    const handleCloseModal = () => {
        setShowModal(false);
    }

    return(
        <div>
            <div className="leave-container">
                <br/>
                <div>
                    <button className="btn btn-success ms-3" onClick={(e) => {e.preventDefault(); navigate("/leave")}}>BOUSER Leave Apply</button>
                </div>
                <br/>
                <div>
                    <UsersLeaveCountList />
                </div>
                <div className="leave-table-1">
                    <LeaveList leavelist={leaveRequestList} loading={leaveRequestListLoading} title="request" onApprovalButton={onApprovalButton} userList={userList}/>
                </div>
                <div className="leave-table-2">
                    <LeaveList leavelist={onLeavelist} loading={onLeaveListLoading} title="leave" userList={userList} onCancelButton={onCancelButton}/>
                </div>
            </div>
            <NotificationModal
                show={showModal}
                message={errorMessage}
                onClose={handleCloseModal}
            />
        </div>
    );
};